import { render } from "./AddAuction.vue?vue&type=template&id=677cd5fb&scoped=true"
import script from "./AddAuction.vue?vue&type=script&lang=js"
export * from "./AddAuction.vue?vue&type=script&lang=js"

import "./AddAuction.vue?vue&type=style&index=0&id=677cd5fb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677cd5fb"]])

export default __exports__